import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { BeneficiarioCriptomoneda } from 'src/app/dashboard/interfaces/beneficiario-criptomoneda.interface';
import { RecipientCriptoService } from 'src/app/dashboard/services/recipient-cripto.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import {
  beneficiarioPausado,
  EstadoRed,
  etiquetaCortaRed,
  redDeBeneficiario,
} from 'src/app/shared/utils/red-cripto';
import { DialogBeneficiarioCriptoComponent } from '../dialog-beneficiario-cripto/dialog-beneficiario-cripto.component';

@Component({
  selector: 'app-recipient-cripto-list',
  templateUrl: './recipient-cripto-list.component.html',
  styleUrls: ['./recipient-cripto-list.component.sass']
})
export class RecipientCriptoListComponent implements OnInit, OnDestroy {
  usuarioID: number | undefined;
  @Output() reloadAccountList: EventEmitter<any> = new EventEmitter();
  @Output() actualizarCuenta: EventEmitter<BeneficiarioCriptomoneda> = new EventEmitter();
  @Output() seleccion: EventEmitter<BeneficiarioCriptomoneda> = new EventEmitter();
  subscriptions: Subscription = new Subscription();
  @Input() listaCuentas: BeneficiarioCriptomoneda[] = [];

  @Input() seleccionable: boolean = false;
  /** Encendida/pausada de cada red (de `medios-cripto`). Vacío = todas activas. */
  @Input() estadoRedes: EstadoRed[] = [];
  cuentaSeleccionada: BeneficiarioCriptomoneda | undefined;

  expandedCardId: number | null = null;

  displayedColumns: string[] = ['nombre', 'red', 'wallet', 'acciones'];

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private spinner: SpinnerService,
    private accountRecipientService: RecipientCriptoService,
  ) {}

  toggleCard(id: number | undefined): void {
    if (!id) return;
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  /**
   * La red de cada beneficiario, ahora que no son todos TRC20 (la tarjeta
   * móvil decía "TRC20" fijo).
   */
  etiquetaRed(cuenta: BeneficiarioCriptomoneda): string {
    return etiquetaCortaRed(redDeBeneficiario(cuenta), cuenta.medioCriptomoneda_descripcion);
  }

  /** Red pausada: se marca, pero se puede ver, editar y eliminar igual. */
  pausado(cuenta: BeneficiarioCriptomoneda): boolean {
    return beneficiarioPausado(cuenta, this.estadoRedes);
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // Acciones tabla
  verCuenta(cuenta: BeneficiarioCriptomoneda): void {
    const isMobile = window.innerWidth < 768;
    this.dialog.open(DialogBeneficiarioCriptoComponent, {
      data: cuenta,
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '500px',
      minWidth: isMobile ? '90vw' : '420px',
      maxHeight: '90vh',
    });
  }

  async inactivarCuenta(cuenta: BeneficiarioCriptomoneda): Promise<void> {
    if (!cuenta || !cuenta.beneficiario_id) return;
    const result = await Swal.fire({
      title: '¿Está seguro de que desea desvincular esta cuenta?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      confirmButtonColor: '#1e5a3f',
    });
    if (result.isDenied || !result.isConfirmed) return;
    const spinnerRef = this.spinner.start();
    try {
      await this.accountRecipientService.inactivateAccount(cuenta.beneficiario_id);
      this.snackBar.open('Cuenta eliminada correctamente', 'Ok', { duration: 3000 });
      this.reloadAccountList.emit();
    } catch (error) {
    }
    this.spinner.stop(spinnerRef);
  }

  actualizar(cuenta: BeneficiarioCriptomoneda): void {
    this.actualizarCuenta.emit(cuenta);
  }

  seleccionar(cuenta: any): void {
    if (!this.seleccionable) return;
    // Elegirlo sería para enviarle, y a una red pausada no se puede.
    if (this.pausado(cuenta)) return;
    if (this.cuentaSeleccionada && this.cuentaSeleccionada?.beneficiario_id !== cuenta.beneficiario_id) {
      this.cuentaSeleccionada.seleccionado = false;
    }
    cuenta['seleccionado'] = cuenta['seleccionado'] ? !cuenta['seleccionado'] : true;
    if (cuenta.seleccionado) {
      this.cuentaSeleccionada = cuenta;
      this.seleccion.emit(cuenta);
    } else {
      this.seleccion.emit(undefined);
      this.cuentaSeleccionada = undefined;
    }
  }
}
